import React from 'react'
import { Tag, Tooltip } from 'antd'
import { accountTierLabel } from '../../utils'

interface AccountTierTagProps {
  tier?: string
  disabled?: boolean
  occupiesSeat?: boolean
}

const AccountTierTag: React.FC<AccountTierTagProps> = ({
  tier,
  disabled = false,
  occupiesSeat = false,
}) => {
  const paid = accountTierLabel(tier) === 'Paid'
  const tag = (
    <Tag
      bordered={false}
      className={`um-refactor__tier um-refactor__tier--${paid ? 'paid' : 'free'}${disabled ? ' um-refactor__tier--inactive' : ''}`}
    >
      {paid ? 'Paid' : 'Free'}
    </Tag>
  )

  if (disabled && paid && occupiesSeat) {
    return <Tooltip title="Does not occupy a paid seat while disabled">{tag}</Tooltip>
  }

  return tag
}

export default AccountTierTag
